var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var TranslationBatchController = {
    /*****************************************************************************************************
        * Is using route "api/translationBatch/batches/{groupId}/{context?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @param {string} context
        * @returns {TranslationBatchDownloadDto[]}
    ******************************************************************************************************/
    GetTranslationBatches: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/batches/{groupId}/{context?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translationBatch/batch/{batchId}/{groupId}/{context?}" and http method "GET" to call the back-end.
    
        * @param {string} batchId
        * @param {string} groupId
        * @param {string} context
        * @returns {TranslationBatchDownloadDto}
    ******************************************************************************************************/
    GetTranslationBatch: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/batch/{batchId}/{groupId}/{context?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translationBatch/states/{batchId}/{groupId}/" and http method "GET" to call the back-end.
    
        * @param {string} batchId
        * @param {string} groupId
        * @returns {TranslationProjectStateDownloadDto[]}
    ******************************************************************************************************/
    GetTranslationProjectStates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/states/{batchId}/{groupId}/", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translationBatch/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} name
        * @param {string} context
        * @returns {TranslationBatchDownloadDto}
    ******************************************************************************************************/
    AddTranslationBatch: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("name", JSON.stringify(data.name));
        if (data.context !== undefined)
            fd.append("context", JSON.stringify(data.context));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translationBatch/{batchId}/fileEntry/{entryId}" and http method "POST" to call the back-end.
    
        * @param {string} batchId
        * @param {string} entryId
        * @param {Record<string, any>} metadata
        * @returns {TranslationBatchDownloadDto}
    ******************************************************************************************************/
    AddFileEntry: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.metadata !== undefined)
            fd.append("metadata", JSON.stringify(data.metadata));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/{batchId}/fileEntry/{entryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/translationBatch/{batchId}/start/secure" and http method "POST" to call the back-end.
    
        * @param {string} batchId
        * @returns {TranslationBatchDownloadDto}
    ******************************************************************************************************/
    StartTranslationSecure: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/{batchId}/start/secure", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translationBatch/{batchId}/start" and http method "POST" to call the back-end.
    
        * @param {string} batchId
        * @returns {TranslationBatchDownloadDto}
    ******************************************************************************************************/
    StartTranslation: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/{batchId}/start", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translationBatch/{batchId}/stop" and http method "POST" to call the back-end.
    
        * @param {string} batchId
        * @returns {TranslationBatchDownloadDto}
    ******************************************************************************************************/
    StopTranslation: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translationBatch/{batchId}/stop", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=TranslationBatchController.js.map